import { createEventBus, EventBus } from '@solid-primitives/event-bus';
import { AlertType } from '@trimble/types';

export type NotificationDelayLength = 'short' | 'medium' | 'long';

export interface AppNotification {
  type: AlertType;
  message: string;
  delay?: number | NotificationDelayLength;
}

export const NotificationEventBus: EventBus<AppNotification> =
  createEventBus<AppNotification>();
